export default __webpack_public_path__ + "static/media/gold-heart-shape.dea330cf.svg";